import { PaymentFrequency, PaymentMethod } from '../../core/reducers/financialCalculators';
export const tabType = {
    finance: 'finance',
    lease: 'lease',
    rebate: 'rebate',
};
export const tabTypeToPaymentMethodMap = {
    [tabType.finance]: PaymentMethod.finance,
    [tabType.lease]: PaymentMethod.lease,
    [tabType.rebate]: PaymentMethod.cash,
};
export const variant1 = 'variant1';
export const variant2 = 'variant2';
export { PaymentFrequency, PaymentMethod };
